document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 749) return;

  document.querySelectorAll('slideshow-slide.product-media-container--image').forEach(function (slide) {
    if (slide.querySelector(':scope > .js-open-product-link')) return;

    var card = slide.closest('.card, .card-wrapper, .grid__item, .product-item, .product-card');
    if (!card) return;

    var productLink = card.querySelector('a[href*="/products/"]');
    if (!productLink) return;

    if (getComputedStyle(slide).position === 'static') {
      slide.style.position = 'relative';
    }

    var overlayLink = document.createElement('a');
    overlayLink.href = productLink.href;
    overlayLink.className = 'js-open-product-link';
    overlayLink.setAttribute('aria-label', 'Abrir producto');
    overlayLink.style.position = 'absolute';
    overlayLink.style.inset = '0';
    overlayLink.style.zIndex = '20';
    overlayLink.style.display = 'block';
    overlayLink.style.background = 'transparent';

    slide.appendChild(overlayLink);
  });
});